import React from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import Header from "../Components/Headers";
import OrderDetails from "../Components/OrderDetails";
import BarReport from "./Pages/BarReport";

export default function Bar() {
  const { url } = useRouteMatch();
  return (
    <React.Fragment>
      <Header Layout="Bar" />
      <main className="pt-60">
        <Switch>
          <Route path={url} exact>
            <OrderDetails display="bar" />
          </Route>
          <Route path={url + `/Report/`} exact component={BarReport} />
        </Switch>
      </main>
    </React.Fragment>
  );
}
